export default "__VITE_ASSET__CkdRA457__"